import { render, staticRenderFns } from "./VTablePlus.vue?vue&type=template&id=90d05900&scoped=true&"
import script from "./VTablePlus.vue?vue&type=script&lang=js&"
export * from "./VTablePlus.vue?vue&type=script&lang=js&"
import style0 from "./VTablePlus.vue?vue&type=style&index=0&id=90d05900&scoped=true&lang=scss&"
import style1 from "./VTablePlus.vue?vue&type=style&index=1&id=90d05900&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d05900",
  null
  
)

export default component.exports